export const LoginFromIframeEvents = {
  LoginState: 'LOGIN_STATE',
  CloseLoginModal: 'LOGIN_MODAL_CLOSE',
  OpenSocialWindow: 'SOCIAL_LOGIN_OPEN',
  CloseSocialWindow: 'SOCIAL_LOGIN_CLOSE',
  UpdateBanner: 'UPDATE_BANNER',
  CustomerProfile: 'CUSTOMER_PROFILE',
  ConfirmSkip: 'CONFIRM_SKIP',
};

export const LoginToIframeEvents = {
  AuthLocation: 'AUTH_LOCATION',
  ResendOTP: 'RESEND_OTP',
};

export const LoginStates = {
  LoggedIn: 'LOGGED_IN',
  LoggedOut: 'NOT_LOGGED_IN',
};

export default {
  LoginFromIframeEvents,
  LoginToIframeEvents,
  LoginStates,
};
